export default __webpack_public_path__ + "static/media/distillery.8c302a13.svg";